import type { ForwardRefExoticComponent, RefAttributes } from 'react';
import React, { forwardRef } from 'react';

import type { FlexItemProps } from './Flex.types';
import { useClassNameAndInlineStyles } from './FlexItem.styles';

const FlexItem: ForwardRefExoticComponent<FlexItemProps & RefAttributes<HTMLDivElement>> = forwardRef<
  HTMLDivElement,
  FlexItemProps
>(({ children, ariaHidden, role, id, testId, ariaLabelledBy, tabIndex, ...styleProps }, ref) => {
  const styling = useClassNameAndInlineStyles(styleProps);

  return (
    <div
      role={role}
      id={id}
      aria-hidden={ariaHidden}
      className={styling.className}
      style={styling.inlineStyles}
      ref={ref}
      data-testid={testId}
      aria-labelledby={ariaLabelledBy}
      tabIndex={tabIndex}
    >
      {children}
    </div>
  );
});

FlexItem.displayName = 'FlexItem';

/**
 * A `FlexItem` component renders a div with flex-item styles.
 */
export default FlexItem;
